import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { getPendantColor } from '../../utils/color';
import { getPageSameType, toTop, isWeb} from '../../utils/util';
import { inject, observer } from 'mobx-react';
import { IComponentSlideHead } from '../../component.d';
import { style } from '../../utils/image';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import Mask from '../Mask';
import { toJpeg } from 'html-to-image';
import ReactCopy from 'react-copy-to-clipboard';
import ReactSVG from 'react-svg';
import { getActionDate } from '../ComponentNavigator/PosterPortal';
import {TemplateComponent} from '../ComponentNavigator/Poster/PosterTemplate';
import wxUtil from '../../utils/wx';
const { getTitle, getShareUrl } = wxUtil;
const { CopyToClipboard } = ReactCopy;

interface IShareButton {
  rootStore?: RootStore;
  isFold: boolean;
}

const shareModalRef = window.document.createElement('div');
shareModalRef.className = 'pendant-share-portal';

const shareQrcodeRef = window.document.createElement('div');
shareQrcodeRef.className = 'pendent-share-qrcode';
shareQrcodeRef.id = 'pendant-share';

export const ShareQrcode = (props: {
  onClose: () => void;
  isFold: boolean;
  videoTotal?: number;
}) => {
  const getImage = () => {
    let head = getPageSameType(window.pageDetail.template, [], 'slidehead');
    if (head && head.length) {
      let { slides } = head[0] as any;
      if (slides && slides.length) {
        // return style(slides[0].image, 'wx_750_n');
        return `//image6.jimage.cn/${slides[0].image}?x-oss-process=image/resize,m_lfit,w_1366,limit_1/quality,Q_90/format,jpg`;
      }
    }

    let videoh = getPageSameType(window.pageDetail.template, [], 'videoh');
    if(videoh && videoh.length) {
      let item = videoh[0] as any;
      if(item && item.thumb) {
        return `//image6.jimage.cn/${item.thumb}?x-oss-process=image/resize,m_lfit,w_1366,limit_1/quality,Q_90/format,jpg`;
      }
    }

    return '';
  };

  useEffect(() => {
    window.document.body.appendChild(shareQrcodeRef);

    return () => {
      if (shareQrcodeRef && shareQrcodeRef.parentNode) {
        window.document.body.removeChild(shareQrcodeRef);
      }
    };
  }, []);

  const [imageData, setImageData] = useState('');
  useEffect(()=>{
    let dom = window.document.querySelector('.share-qrcode-modal .poster-template.template2') as HTMLDivElement;

    if(dom) {
      // 先加载一下指定图片
      let imageUrl = getImage();
      let image = new Image();
      image.onload = ()=>{
        toJpeg(dom, {
          quality: 0.9,
          pixelRatio: 1,
        }).then(()=>{
          toJpeg(dom, {
            quality: 0.9,
            pixelRatio: 1,
          }).then(dataUrl=>{
            setImageData(dataUrl);
          });
        })
      };
      image.src = imageUrl;
    }
  }, []);

  const zoom = Math.min(750, window.document.body.clientWidth) / 750;

  return createPortal(
    <>
      {props.isFold ? null : <Mask />}
      <div className="share-qrcode-modal">
        <div className="modal-content" style={{zoom}}>
          <TemplateComponent
            templateId={2}
            img={getImage()}
            total_uv={props.videoTotal}
          />
        </div>
        <div className="modal-footer">
          {isWeb() ? intl.get('Click to save') : intl.get('Long-press to save')}
        </div>
        <img src={imageData} className="image-opacity" />
        <a className="modal-close" onClick={props.onClose}>
          <img src={require('../../assets/x-36.png')} />
        </a>
      </div>
    </>,
    shareQrcodeRef
  );
};

export const ShareModal = (props:{
  isFold:boolean,
  showModal:boolean,
  onQrcodeClick:()=>void,
  onLinkClick:()=>void,
  onClose:()=>void,
})=>{
  const {isFold, showModal, onQrcodeClick, onLinkClick, onClose} = props;

  useEffect(() => {
    if (showModal) {
      window.document.body.appendChild(shareModalRef);
    }

    return () => {
      if (shareModalRef && shareModalRef.parentNode) {
        window.document.body.removeChild(shareModalRef);
      }
    };
  }, [showModal]);

  return createPortal(
    <>
      {isFold ? null : <Mask />}
      <div className="share-modal">
        <div className="modal-title">{intl.get('PleaseShare')}</div>
        <div className="modal-content">
          <div
            className="share-type"
            onClick={onQrcodeClick}
          >
            <div className="share-icon">
              <ReactSVG
                  style={{
                    width: 32,
                    height: 32,
                  }}
                  src={require('../../svg/share-svg-lined.svg')}
              />
            </div>
            <div className="share-name">{intl.get('ShareQrcode')}</div>
          </div>
          <CopyToClipboard
            text={getShareUrl()}
            onCopy={onLinkClick}
          >
            <div className="share-type">
              <div className="share-icon">
                <ReactSVG
                    style={{
                      width: 32,
                      height: 32,
                    }}
                    src={require('../../svg/link.svg')}
                />
              </div>
              <div className="share-name">{intl.get('ShareLink')}</div>
            </div>
          </CopyToClipboard>
        </div>
        <a className="modal-close" onClick={onClose}>
          <img src={require('../../assets/x-36.png')} />
        </a>
      </div>
    </>,
    shareModalRef
  );
};

const ShareButton = (props: IShareButton) => {
  const [showModal, setShowModal] = useState(false);
  const [showQrcode, setShowQrcode] = useState(false);
  const { uiStore, videoStore} = props.rootStore!;

  const getVideoTotal = ()=>{
    if(window.pageDetail.video_data && window.__share_show_view) {
      let video = videoStore.getVideo(Number(window.pageDetail.video_data));
      if(video) {
        return Math.max(0, Number(video.view));
      }
    }
    return 0;
  };

  return (
    <>
      <NormalButton
        className="pendant-share"
        onClick={() => {
          setShowModal(true);
        }}
      >
        {intl.get('Share')}
      </NormalButton>
      {/*showModal ? renderModal() : null*/}
      {showModal ? <ShareModal showModal={showModal} isFold={props.isFold} onQrcodeClick={() => {
        setShowQrcode(true);
        setShowModal(false);
      }} onLinkClick={() => {
        uiStore.showToast({
          content: intl.get('Copyed')
        });
        setShowModal(false);
      }} onClose={() => setShowModal(false)} /> : null}
      {showQrcode ? (
        <ShareQrcode
          videoTotal={getVideoTotal()}
          onClose={() => {
            setShowQrcode(false);
          }}
          isFold={props.isFold}
        />
      ) : null}
    </>
  );
};

export default inject('rootStore')(observer(ShareButton));
